import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { puedeVerPanelAdmin } from '../utils/permisos'

export const UserRoute = () => {
  const { session } = useAuth()

  return puedeVerPanelAdmin(session)
    ? <Navigate to="/admin" replace />
    : <Outlet />
}
